import { shellAssets } from '../../constants/assets'
import { primaryNav, secondaryNav } from '../../data/navigation'
import { RailIconButton } from './RailIconButton'
import { useDashboardBadges } from '../../context/DashboardBadgeContext'

type NavRailProps = {
  activeId: string
  onSelect?: (id: string) => void
  onToggle?: () => void
  onExpand?: () => void
}

export const NavRail = ({ activeId, onSelect, onExpand }: NavRailProps) => {
  const { hasNewEnquiry, hasNewNotification } = useDashboardBadges()

  const dynamicPrimaryNav = primaryNav.map((item) =>
    item.id === 'enquiries'
      ? { ...item, badge: hasNewEnquiry ? ('dot' as const) : undefined }
      : item
  )

  const dynamicSecondaryNav = secondaryNav.map((item) =>
    item.id === 'notifications'
      ? { ...item, badge: hasNewNotification ? ('dot' as const) : undefined }
      : item
  )

  return (
    <div className="flex w-[90px] shrink-0 flex-col items-center px-[20px] py-[19px]">
      <div className="flex w-full flex-col items-center gap-[40px]">
        <div className="flex w-full flex-col items-center gap-[54px]">
          <img
            alt="Salzburg Cab"
            className="block h-[44px] w-[88px] max-w-none shrink-0 object-cover"
            src={shellAssets.logo}
          />

          <nav aria-label="Dashboard" className="flex flex-col items-center gap-[20px]">
            <div
              onMouseEnter={onExpand}
              className="flex w-[54px] shrink-0 flex-col items-center rounded-[23.723px] bg-white px-[9.705px] py-[18.331px] shadow-dash-rail cursor-pointer"
            >
              <div className="flex flex-col items-center justify-center gap-[8px]">
                {dynamicPrimaryNav.map((item) => (
                  <RailIconButton key={item.id} item={item} active={item.id === activeId} onSelect={onSelect} />
                ))}
              </div>
            </div>

            <div
              onMouseEnter={onExpand}
              className="flex w-[53px] shrink-0 flex-col items-center justify-center gap-[9px] rounded-[24px] bg-white px-[10px] py-[14px] shadow-dash-rail-sm cursor-pointer"
            >
              {dynamicSecondaryNav.map((item) => (
                <RailIconButton key={item.id} item={item} onSelect={onSelect} />
              ))}
            </div>
          </nav>
        </div>
      </div>
    </div>
  )
}
